import { isDTRuntime } from "@/modules/3rd-party-integration/utils/env";
import { DingtalkModule } from "@/modules/dingtalk/lazy-load";
import store from "@/store";
import { isCNDomain, isJPDomain, updateProp, windowActionFn } from "@/utils/utils";

function getDownloadUrl() {
    const { full } = store.appStore.lng;
    const URLS = {
        CN_WINDOWS: 'https://cdn07.foxitsoftware.cn/pub/foxit/phantomPDF/desktop/win/12.x/12.1/zh_cn/12.1.2/GA_PDFEditor_ZhEn_Online_CNPhantomOnline_Bundle_v12.1.2.15332.exe',
        CN_MAC: 'https://cdn07.foxitsoftware.cn/pub/foxit/phantomPDF/desktop/mac/12.x/12.1/zh_cn/FoxitPDFEditor_zh_Setup_mac_CNPhantomOnline_1210.pkg',
        COM_URL: `https://globe-map.foxitservice.com/go.php?title=download-phantom&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=online-view-window&language=${full}`,
        COM_MAC_URL: `https://globe-map.foxitservice.com/go.php?title=download-phantom-mac&product=Foxit%20PhantomPDF%20Online&&edition=&version=&utm_source=online-view-window&language=${full}`,
        JP: 'https://www.foxit.co.jp/downloads/download.php?id=6'
    };

    const isCN = isCNDomain();
    const isJP = isJPDomain();
    const { isWindowsOS, isMacOS } = store.appStore;

    if (isCN) {
        if (isWindowsOS) return URLS['CN_WINDOWS'];
        if (isMacOS) return URLS['CN_MAC'];
        return '';
    }
    if (isJP) return URLS['JP'];
    if (isMacOS) return URLS['COM_MAC_URL'];
    return URLS['COM_URL'];
}

export default function doDownloadClient() {
    if (!window.__online__) {
        store.appStore.doNotifyErrors('offline');
        return;
    }
    const url = getDownloadUrl();
    if (!url) {
        throw new Error('can not download file, a invalid file url');
    }
    if (isDTRuntime) {
        DingtalkModule.openLink(url);
        return;
    }

    const winEnv = windowActionFn(window, 'open', ['about:blank']);
    updateProp(winEnv.document.location, 'href', url);
}
